import Cta from "@components/Cta/Cta";
import { GeneralLink } from "@customTypes/generalLink";
import React from "react";
import styles from "./C03.1_SubNavigationDE.module.scss";

interface NavCtasProps {
  ctaButton1?: string;
  ctaButton1Text?: string;
  ctaLink1?: GeneralLink;
  onClickHandler: () => void;
  applyNowUrl: string;
}

const NavCtas: React.FC<NavCtasProps> = ({
  ctaButton1,
  ctaButton1Text,
  ctaLink1,
  onClickHandler,
  applyNowUrl,
}) => {
  return (
    <div className={styles["button-wrappers"]}>
      {ctaButton1 &&
        (ctaButton1 === "Use CTA Link 1" && ctaLink1 ? (
          <Cta id="cta-link1" {...ctaLink1.fields} type="secondary" light />
        ) : ctaButton1 === "Emba Merge Apply Now" ? (
          <Cta
            id="emba-merge-apply-now"
            linkText={
              ctaButton1 === "Emba Merge Apply Now"
                ? "Apply Now"
                : ctaButton1Text
            }
            type="secondary"
            url=""
            light
            onClick={onClickHandler}
          />
        ) : (
          <Cta
            id="apply-now"
            linkText={
              ctaButton1 === "Apply Now CTA" ? "Apply now" : ctaButton1Text
            }
            type="secondary"
            url={applyNowUrl}
            light
          />
        ))}
    </div>
  );
};

export default NavCtas;
